<ng-container *notInPopulation="[populations.JuniorBluebirds]">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="'games.page.title' | translate"></fgb-banner>
  </div>
  <div class="d-lg-none">
    <fgb-mobile-page-header
      pageTitle="games.page.title"
      [showFooter]="true"
      [showQr]="true"
      [backButtonLink]="'/'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.JuniorBluebirds]">
  <fgb-banner [isImageBanner]="true" [imageBannerUrl]="'banners/kids-games-banner.jpg'" class="d-lg-flex d-none"></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-mobile-page-header
      pageTitle="games.page.title"
      [showFooter]="true"
      [backButtonLink]="'/'"
      [isImageBanner]="true"
      [imageBannerUrl]="'banners/kids-games-banner.jpg'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>

<div class="container mt-lg-4">
  <div class="game-container-sections">
    <div>
      <img [src]="'games/trivia.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-black">{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/trivia'" class="mt-3">
          <div class="btn btn-primary bg-primary bg-corporate-primary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div>
      <img [src]="'games/polls.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-black">{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'" class="mt-3">
          <div class="btn btn-primary bg-primary bg-corporate-primary">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-container-sections mt-4">
    <div>
      <img [src]="'games/predictors.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-black">{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn btn-primary bg-primary bg-corporate-primary">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      <img [src]="'games/pickaplayer.jpg' | contentAssetImage" />
      <div class="card">
        <div class="">
          <h5 class="text-black">{{ 'games.page.pap' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/pickaplayer'">
          <div class="btn btn-primary bg-primary bg-corporate-primary">{{ 'games.page.pap.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
